import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import Buyer from '../contract-policies/buyer';
import Seller from '../contract-policies/seller';
import { CircularProgress } from 'material-ui';
import ContractDetailsWithFiles from '../contract-policies/contract-request-buyer-view/old-router';
import {
  getContractDetails,
} from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';

class ContractDetails extends Component {
  componentWillMount() {
    const { contractId, params, rightSideLoaded } = this.props;
    // if data has not been loaded, do load
    if (!(contractId === params.contractId && rightSideLoaded)) {
      this.props.getContractDetails('contract', params.contractId);
    }
  }
  render() {
    if (this.props.loading) {
      return (
        <div style={{ textAlign: 'center', paddingTop: '56px' }}>
          <CircularProgress size={100} thickness={7}/>
        </div>
      );
    }

    if (this.props.isRequest && (this.props.isSender)) {
      return <ContractDetailsWithFiles />;
    }
    return (
      <div>
        <Seller {...this.props} />
        <Buyer {...this.props} />
      </div>
    );
  }
}

ContractDetails.propTypes = {
  email: PropTypes.string,
  buyerChecked: PropTypes.bool,
  locationId: PropTypes.string,
  getContractDetails: PropTypes.func,
  params: PropTypes.object,
  loading: PropTypes.bool,
  isSender: PropTypes.bool,
  isRequest: PropTypes.bool,
  from: PropTypes.object,
  contractId: PropTypes.string,
  rightSideLoaded: PropTypes.bool,
};

const mapStateToProps = ({ contracting, user }, { params }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return ({
    loading: contracting.contractActivitiesProducts.get('contentLoading'),
    rightSideLoaded: rightSideContent[`${params.contractId}Loaded`],
    ...rightSideContent,
    state: leftNav.state,
    isSender: leftNav.isSender,
    isRequest: leftNav.isRequest,
    respondedContractList: leftNav.respondedContractList,
    supplierEditable: leftNav.supplierEditable,
    contractorEditable: leftNav.contractState === 'pending' && user.getIn(['user', 'type']) === 'Contractor',
  });
};
export default connect(mapStateToProps, ({
  getContractDetails,
}))(ContractDetails);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/contract-policies.jsx